<base-modal
			[title]="title"
			[isLoading]="isLoading"
			[btnOkClass]="btnOkClass"
			[btnOkLabel]="btnOkLabel"
			[btnCloseDisplay]="false"
			(onOk)="ok()"
	>
		<ng-content></ng-content> 
	</base-modal>